import { useState } from 'react';
import { SMSAuthModal } from './auth/SMSAuthModal';

interface WelcomeScreenProps {
  onAutoHide?: () => void;
  isAuthenticated: boolean;
}

export function WelcomeScreen({ onAutoHide, isAuthenticated }: WelcomeScreenProps) {
  const [showAuthModal, setShowAuthModal] = useState(false);

  return (
    <>
      <div className="fixed inset-0 z-[200] bg-gradient-to-br from-gray-800 via-gray-900 to-gray-800 flex flex-col items-center justify-center p-6">
        {/* Logo */}
        <div className="mb-8 animate-fade-in">
          <img
            src="/logotype-white.png"
            alt="Level Sport Club"
            className="h-32 w-auto drop-shadow-2xl"
          />
        </div>

        {/* Title */}
        <h1 className="text-4xl md:text-5xl font-bold text-white text-center mb-4 animate-fade-in-delay-1">
          Level Sport Club
        </h1>

        {/* Description */}
        <p className="text-xl text-gray-300 text-center mb-12 max-w-md animate-fade-in-delay-2">
          Фитнес • Бассейн • Теннис • SPA • Ресторан
        </p>

        {/* Login Buttons - только для неавторизованных */}
        {!isAuthenticated && (
          <div className="flex flex-col gap-4 w-full max-w-md px-6 animate-fade-in-delay-3">
            <button
              onClick={() => setShowAuthModal(true)}
              className="bg-emerald-600 text-white px-12 py-4 rounded-2xl text-lg font-bold shadow-2xl hover:bg-emerald-700 transition-all transform hover:scale-105"
            >
              Войти в Level Sport Club
            </button>
            <button
              onClick={() => {
                window.location.href = '/landing/index.html';
              }}
              className="bg-white/10 backdrop-blur-sm text-white px-12 py-4 rounded-2xl text-lg font-semibold shadow-2xl hover:bg-white/20 transition-all border-2 border-white/30"
            >
              Продолжить как гость
            </button>
          </div>
        )}

        {/* Loading indicator для авторизованных */}
        {isAuthenticated && (
          <div className="flex flex-col items-center animate-fade-in-delay-3">
            <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin mb-4"></div>
            <p className="text-white text-lg">Загрузка...</p>
          </div>
        )}

        {/* Decorative elements */}
        <div className="absolute top-10 left-10 w-32 h-32 bg-white/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-40 h-40 bg-white/10 rounded-full blur-3xl"></div>
      </div>

      {/* SMS Authentication Modal */}
      {showAuthModal && (
        <SMSAuthModal onClose={() => setShowAuthModal(false)} />
      )}

      <style>{`
        @keyframes fade-in {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-fade-in {
          animation: fade-in 0.6s ease-out;
        }

        .animate-fade-in-delay-1 {
          animation: fade-in 0.6s ease-out 0.2s both;
        }

        .animate-fade-in-delay-2 {
          animation: fade-in 0.6s ease-out 0.4s both;
        }

        .animate-fade-in-delay-3 {
          animation: fade-in 0.6s ease-out 0.6s both;
        }
      `}</style>
    </>
  );
}
